export default "__VITE_ASSET__CkmtXh25__"